import { useEffect } from 'react';

import FinList from '../FinList';

import { Helmet } from "react-helmet";

const FinListUS = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.finlist.us = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>FinList (US) - Finetic App</title>
			</Helmet>
			<FinList exchange="US" />
		</>
	);
};

export default FinListUS;
